// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { purchasedProductsStyles } from "@guestsupply/Overrides/Widgets/Common/PurchasedProducts";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

purchasedProductsStyles.container = {
    css: css`
        margin: 25px 0;
    `,
};

purchasedProductsStyles.titleText = {
    variant: "h2",
    css: css`
        text-align: center;
        margin-bottom: 10px;
    `,
};

purchasedProductsStyles.headerContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        background-color: ${color("common.ui2")};
        padding: 5px;
    `,
};

purchasedProductsStyles.itemHeaderWrapper = {
    css: css`
        padding-left: 10px;
    `,
};

purchasedProductsStyles.itemHeaderText = { weight: "bold" };

purchasedProductsStyles.addToCartHeaderWrapper = {
    css: css`
        width: 315px;
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};

purchasedProductsStyles.addToCartHeaderText = { weight: "bold" };

purchasedProductsStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0;
            border: initial;
        `,
    },
    gridItem: {
        css: css`
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
};

purchasedProductsStyles.productListProductCard = {
    productListContainerStyles: {
        container: {
            css: css`
                height: 100%;
                position: relative;
                display: flex;
                flex-direction: row;
                max-width: initial;
                min-width: initial;
                width: 100%;
                ${xScreen("lte", "md")} {
                    max-width: initial;
                }
                ${xScreen("lte", "sm")} {
                    max-width: initial;
                    flex-wrap: wrap;
                    .bottom-section {
                        width: 100%;
                        max-width: none;
                    }
                }
            `,
        },
        priceAndActions: {
            css: css`
                display: flex;
                flex-direction: column;
                gap: 8px;
                ${xScreen("lte", "sm")} {
                    padding-left: 0;
                    border-left: none;
                    padding-bottom: 10px;
                    border-bottom: 1px solid ${color("common.border")};
                    & > div {
                        width: 100%;
                        max-width: none;
                    }
                }
            `,
        },
    },
};
